module.exports = __webpack_public_path__ + "img/icon_white-small_dollar-sign.d8b7a8af.svg";